export default __webpack_public_path__ + "static/media/close.454f76b2.svg";